module.exports = __webpack_public_path__ + "static/media/buildings_bw.ec9f4888.jpg";